<div class="flex-container">
 <button type="button" class="btn-search dark" (click)="showCountrySearch()"> <i *ngIf="!isDisabled" class="icofont-search"></i> {{textLabel}} <img *ngIf="!!selectedCountryFlag" (click)="showCountrySearch()" [src]="selectedCountryFlag | flagUrl" width="35"></button>
  <app-country-search *ngIf="showCountry" [countries]="countries$ | async" [isDisabled]="isDisabled" [import]="import"
  [defaultValue]="defaultValueCountry" [placeAddHolderLabel]="placeAddHolderLabel"
  (selectedCountry)="selected($event)"></app-country-search>
</div>
